module.exports = __webpack_public_path__ + "components/incentive/static/snow-history-bea8313908a3be5b9096939d0d4f1455.svg";